import { render, staticRenderFns } from "./DropHereIcon.vue?vue&type=template&id=bd8bf076&"
import script from "./DropHereIcon.vue?vue&type=script&lang=js&"
export * from "./DropHereIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports